import gsap from 'gsap';
import Viewport from './core/Viewport';
import Components from './core/Components';
import lazySizes from './lib/lazysizes';
import AnimatedLinks from './lib/AnimatedLinks';
import Revealer from './lib/Revealer';
import Transition from './lib/Transition';

import { isLivePreview } from './lib/helpers';
import Dispatch from './core/Dispatch';
import { REDUCED_MOTION_CHANGE } from './lib/events';

gsap.defaults({ overwrite: 'auto' });

const init = () => {

    Viewport.init();
    Components.init();
    Viewport.initTabbing();
    lazySizes.init();
    AnimatedLinks.init();

    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce), (update: slow)');

    const onReduceMotionChange = () => {
        if (!reduceMotionQuery.matches) {
            if (!isLivePreview()) {
                Revealer.init();
                Transition.init();
            }
        } else {
            Revealer.destroy();
            Transition.destroy();
        }
        Dispatch.emit(REDUCED_MOTION_CHANGE, !!reduceMotionQuery.matches);
    };

    onReduceMotionChange();

    reduceMotionQuery.onchange = onReduceMotionChange;

    // Init anchor links
    document.addEventListener('click', e => {
        // Find the closest anchor element to the clicked target
        const link = e.target.closest('a[href^="#"]');

        // If it's a valid anchor and part of the document
        if (link && document.contains(link) && !link.closest('[role="dialog"]')) {
            // If user is holding Cmd (macOS) or Ctrl (Windows/Linux), let the default action happen
            if (e.metaKey || e.ctrlKey) {
                return; // Do not prevent default or run custom logic
            }

            const targetId = link.getAttribute('href').replace('#', '');
            const target = document.getElementById(targetId);
            if (!target) {
                console.warn(`Target with ID ${targetId} does not exist in the document.`);
                return;
            }

            e.preventDefault();
            e.stopPropagation();
            try {
                target.focus({ preventScroll: true });
            } catch (error) {
                console.error(error);
            }

            target.scrollIntoView({ behavior: !reduceMotionQuery.matches ? 'smooth' : 'instant' });
        }
    });

    window.addEventListener('popstate', () => {
        window.location.reload();
    });

    document.body.classList.remove('js:!bg-white');

};

require('doc-ready')(init);
